export default {
  close: {
    id: 'cms_modal_close',
    defaultMessage: 'Close menu',
  },
}
